<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section" id="sect8"><span href="#/OEBPS/toc#sect8" title="Link target outside of Sample">Cranberry Orange Scones</span></h1>
<p class="figure"><img alt="" src="OEBPS/images/18-1.jpg" style="height:70vh"/></p>
<p class="RecipebYieldb">Yield: 8 scones | Prep Time: 15 minutes | Cook Time: 18–21 minutes</p>
<p class="extract_r">Scones are my go-to lazy Sunday morning breakfast food. I love to just sit out on the back deck, book in hand, as I get ready to take on the rest of the day. The use of whole wheat flour and low-fat buttermilk helps make this a lighter version than your typical scone. Feel free to substitute your favorite type of berry for the cranberries!</p>
<p class="ingredients"><strong>INGREDIENTS</strong></p>
<p class="Subheadb"><strong>Scones</strong></p>
<p class="rec">1½ cups whole wheat flour</p>
<p class="rec">1 tablespoon orange zest</p>
<p class="rec">1½ teaspoons baking powder</p>
<p class="rec">½ teaspoon kosher salt</p>
<p class="rec">4 tablespoons cold unsalted butter, cubed</p>
<p class="rec">½ cup low-fat buttermilk</p>
<p class="rec">3 tablespoons maple syrup</p>
<p class="rec">3 tablespoons orange juice</p>
<p class="rec">1 teaspoon vanilla extract</p>
<p class="rec">¾ cup dried cranberries</p>
<p class="rec">2 teaspoons skim milk</p>
<p class="Subheadb"><strong>Glaze</strong></p>
<p class="rec">¼ cup confectioners’ sugar</p>
<p class="rec">1–2 tablespoons orange juice</p>
<p class="directions"><strong>DIRECTIONS</strong></p>
<p class="recpr">1. <em>For the scones:</em> Preheat the oven to 425°F. Line a baking sheet with parchment paper.</p>
<p class="recpr">2. In a medium bowl, combine the flour, orange zest, baking powder, and salt.</p>
<p class="recpr">3. Cut in the cold butter with a pastry cutter until the mixture forms fine clumps.</p>
<p class="recpr">4. Gently stir in the buttermilk, maple syrup, orange juice, and vanilla. Fold in the cranberries.</p>
<p class="recpr">5. Scoop the dough onto the baking sheet and shape the dough in a circle about ¾ inch thick. Brush the top with the milk. Slice the dough into 8 wedges.</p>
<p class="recpr">6. Bake for 18 to 21 minutes until the scones are golden and are cooked through.</p>
<p class="recpr">7. Let the scones cool on the baking sheet for 5 minutes, then transfer to a wire rack to cool further.</p>
<p class="recpr">8. <em>For the glaze:</em> Mix the confectioners’ sugar and orange juice until it reaches a smooth consistency. Drizzle over the cooled scones.</p>
<p class="notehead"><strong>VARIATIONS</strong></p>
<p class="NotebText">Use fresh cranberries instead of dried.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sect8.vue?144b0918